import { tokens } from 'src/design-system';
import { commonStyleSheet } from 'src/Library/CommonStyles';

export const documentRequestStyles = {
  main: {
    width: '100%',
    fontFamily: 'Open Sans',
    letterSpacing: 0,
    backgroundColor: '#FFF',
  },
  header: {
    ...commonStyleSheet.flexRow,
    width: '100%',
    border: '1px solid #F7F7F7'
  },
  tab: {
    textAlign: 'center',
    width: '12%',
    color: '#111',
    fontSize: tokens.fontSize.body,
    cursor: 'pointer',
    padding: 14,
  },
  statusDot: {
    width: 8,
    height: 8,
    borderRadius: 16,
  },
};

const commonStyles = {
  ...commonStyleSheet,
  docList: {
    ...commonStyleSheet.flexRow,
    padding: 14,
    border: '1px solid #F7F7F7',
    boxShadow: '2px 2px 6px 0 rgba(0,0,0,0.05)',
  },
  docCard: {
    padding: tokens.spacing.sm,
    borderRadius: tokens.radius.md,
    border: '1px solid #666',
    marginRight: tokens.radius.md,
    cursor: 'pointer',
    minWidth: 150,
  },
  docName: {
    fontSize: tokens.fontSize.small,
    ...commonStyleSheet.flexRow,
    ...commonStyleSheet.justifySpaceBetween,
  },
  docDate: {
    fontSize: 8,
  },
  addDocument: {
    padding: `${tokens.spacing.xs}px ${tokens.spacing.sm}px`,
    marginLeft: tokens.spacing.sm,
    borderRadius: 13,
    cursor: 'pointer',
    backgroundColor: '#FAFAFA',
    fontWeight: 'bold',
    fontSize: tokens.fontSize.small,
    color: tokens.colors.primaryDark,
    ...commonStyleSheet.ellipses,
  },
  reference: {
    ...commonStyleSheet.flexRow,
    ...commonStyleSheet.justifySpaceBetween,
    padding: 14,
    border: '1px solid #FAF6EF',
    borderRadius: `0 ${tokens.radius.md}px ${tokens.radius.md}px 0`,
    backgroundColor: '#FCFAF4',
    boxShadow: '2px 2px 6px 0 rgba(0,0,0,0.05)',
  },
  referenceValue: {
    fontSize: tokens.fontSize.body,
    color: tokens.colors.text,
    fontWeight: tokens.fontWeight.semibold,
  },
  referenceTitle: {
    fontSize: tokens.fontSize.small,
    color: '#666666',
  },
  referenceList: {
    marginLeft: tokens.spacing.lg,
    marginRight: tokens.spacing.lg,
  },
  contentBox: {
    width: '99%',
    margin: '20px 12px',
  },
  title: {
    color: '#666666',
    lineHeight: '14px',
    marginLeft: tokens.spacing.ms,
    fontSize: tokens.fontSize.small,
  },
  value: {
    maxWidth: '75%',
    overflowWrap: 'break-word',
    color: tokens.colors.text,
    marginLeft: tokens.spacing.ms,
    fontSize: tokens.fontSize.small,
    lineHeight: '14px',
    fontWeight: tokens.fontWeight.semibold,
  },
  na: {
    color: '#999999',
    fontSize: tokens.fontSize.body,
    fontWeight: tokens.fontWeight.semibold,
    letterSpacing: 0,
    lineHeight: '12px',
    width: '50%',
    marginLeft: tokens.spacing.md,
  },
  contentTitle: {
    color: tokens.colors.text,
    fontFamily: 'Open Sans',
    fontSize: tokens.fontSize.h3,
    fontWeight: 'bold',
    letterSpacing: 0,
  },
  line: {
    borderBottom: '1px solid #D9D9D9',
    opacity: 0.5,
    height: 1,
    width: '98%',
    marginTop: 6,
    marginBottom: 20,
  },
  contentRow: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    margin: `${tokens.spacing.lg}px 20px ${tokens.spacing.lg}px ${tokens.spacing.ms}px`,
  },
  collapse: {
    '& .ant-collapse-content-box': {
      padding: 0,
    },
    '& .ant-table-wrapper': {
      margin: 0,
    },
    '& .ant-collapse-header': {
      padding: 0,
    },
    '& .ant-collapse-item': {
      border: 'none',
    },
    '& .ant-collapse-content': {
      border: 'none',
      backgroundColor: '#FEFDFB',
    },
    width: '98%',
    border: 'none',
    borderRadius: `${tokens.radius.md}px ${tokens.radius.md}px 0 0`,
    marginBottom: 5,
    backgroundColor: '#FCFAF4',
  },
  containerTitle: {
    color: '#262626',
    fontSize: tokens.fontSize.body,
    fontWeight: 'bold',
    marginRight: 50,
  },
  status: {
    borderRadius: 12,
    padding: `0px ${tokens.spacing.ms}px`,
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
  },
  button: {
    color: tokens.colors.primaryDark,
    fontSize: tokens.fontSize.body,
    fontWeight: tokens.fontWeight.semibold,
  },
  main: {
    marginBottom: 50,
  },
};

export const vgmStyles = {
  ...commonStyles,
};

export const siStyles = {
  ...commonStyles,
  info: {
    margin: `${tokens.spacing.ms}px ${tokens.spacing.lg}px`,
    color: '#666666',
    fontSize: tokens.fontSize.small,
    fontStyle: 'italic',
  },
  intermediate: {
    color: '#333',
    fontWeight: tokens.fontWeight.semibold,
    margin: `${tokens.spacing.ms}px ${tokens.spacing.lg}px`,
  },
  inttraNotificationMessage: {
    color: '#25BA2B',
    fontStyle: 'italic',
    fontWeight: tokens.fontWeight.semibold,
    fontSize: tokens.fontSize.small,
  },
};
